<template>
  <div class="home">

    <div class="home-back" :style="sliderStyle">
      <div class="home-back-img" :style="sliderStyle">
        <img :src="backimg" :style="sliderStyle">
      </div>
    </div>

    <div class="live-header">
      <div class="live-header-left">
        <div class="header-left-img">
          <img :src="url">
        </div>
        <div class="header-left-sub">
          <div class="header-left-title">{{anchor_name}}</div>
          <!-- <div class="header-left-up">9289本场点赞</div> -->
        </div>
        <div class="header-left-follow" @click="followshow">关注</div>
      </div>
      <!-- <div class="live-header-right">
        <div class="header-right-text">309人</div>
      </div> -->
    </div>

    <div class="liveB">
      <div class="entTime" v-show="isEndTime">
        <!-- <img :src="endImgH5"> -->
        <img :src="liveUri" v-show="isCover">
        <div class="cover-over">
          <span>{{liveStr}}</span>
        </div>
      </div>
      <div class="waitTime" v-show="isWaitTime">
        <img :src="coverUri">
      </div>
      <div class="all" v-show="isScreen" @click="openScreen"><img src="../../assets/liveimg/openscreen.svg"></div>
      <div class="videobox">
        <vue-aliplayer-v2 v-show="isVideo1" ref="VueAliplayerV2" :options="options" @onM3u8Retry="getendtime"  @play="handleReady" />
      </div>
      <!-- <div class="all" @click="openScreen"><img src="../../assets/liveimg/openscreen.svg"></div> -->
    </div>

    <div class="">

      <div class="notice-box">
        <div class="notice-text">
          <strong>直播间公告:</strong>{{roomDesc}}
        </div>
        <div class="recommend-box">
          <div class="recommend-info">
            <div class="recommend-info-box" v-for="(item,i) in goodslist" :key="i" @click="openAppShow" v-if="i==0">
              <div class="recommend-info-img">
                <img :src="item.goodsPicture">
              </div>
              <div class="recommend-goods-box">
                <div class="recommend-goods-title">{{item.goodsName}}</div>
                <div class="recommend-price-box">
                  <div class="recommend-price-text">¥{{item.price | priceFloat}}</div>
                  <div class="recommend-price-img">
                    <img src="../../assets/liveimg/rob.svg">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="openappbox">
        <div class="msgbox-botton" v-if="openPopup == true">
          <span>打开好兽药APP,<strong>查看更多精彩</strong></span>
          <wx-open-launch-app class="launch-btn" :id="id" :appid="appid" :extinfo="wechatOpenAppData">
            <script type="text/wxtag-template">
              <style>.btn {height: 45px;}</style>
              <div class="btn">打开APP</div>
            </script>
          </wx-open-launch-app>
        </div>
        <div class="app-img" @click="openApp" v-else><img src="../../assets/liveimg/open.svg"></div>
      </div>
    </div>

    <!-- <van-overlay :show="openPopup" @click="openPopup = false">
      <div class="wrapper" @click.stop>
        <div class="block">
          <div class="msgbox">
            <h3>直播邀请</h3>
            <p>该直播使用最新版好兽药APP观看</p>
            <p>体验会更好哦，快来看看吧！</p>
            <div class="msgbox-botton">
              <span>打开好兽药APP</span>
              <wx-open-launch-app class="launch-btn" :id="id" :appid="appid" :extinfo="wechatOpenAppData">
                <script type="text/wxtag-template">
                  <style>.openapp-button {height: 45px;}</style>
                  <div class="openapp-button">打开APP</div>
                </script>
              </wx-open-launch-app>
            </div>
          </div>
          <div class="old-close" @click="openAppClose"><img src="../../assets/liveimg/close.svg"></div>
        </div>
      </div>
    </van-overlay> -->

    <van-overlay :show="followPopup" @click="followPopup = false">
      <div class="wrapper-popup" @click.stop>
        <div class="block-popup">
          <div class="msgbox">
            <div class="msgbox-wechat" id="wechat">
              <div class="wechat-logo">
                <img :src="url">
              </div>
              <div class="wechat-title"><span>{{anchor_name}}</span></div>
              <div class="wechat-close" @click="wechatClose">
                <img src="../../assets/liveimg/close.svg">
              </div>
              <div class="wechat-qrcode">
                <div class="QRCode">
                  <img :src="posterImg" alt="">
                </div>
                <!-- <div ref="qrcodeContainer" style="display: none"></div>
                <div class="QRCode" ref="qrCode"></div> -->
              </div>
              <div class="wechat-text">
                <span>长按二维码保存图片-打开微信扫一扫<br> 关注微信公众号，了解更多特价信息</span>
              </div>
              <!-- <div class="wechat-button" @click="wechatDow">
                <img src="../../assets/liveimg/preserve.svg">
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </van-overlay>

  </div>
</template>

<script>
  import QRCode  from "qrcodejs2"
  import html2canvas from "html2canvas"
  import VueAliplayerV2 from 'vue-aliplayer-v2';
  import { iswx, wxshare, secondToDate } from '@/utils/utils.js'
  import { liveDetail, liveStatus } from '@/api/resetApi.js'

  export default {
    name: 'liveBroadcast',
    components: {
      VueAliplayerV2: VueAliplayerV2.Player,
      QRCode
    },
    inject: ['reload'],
    data(){
      return{
        options: {
          source: '//player.alicdn.com/video/aliyunmedia.mp4',
          width: "100%",
          height: "100%",
          cover: '',
          autoplay: true,
          isLive: true,
          rePlay: true,
          playsinline: true,
          preload: true,
          useH5Prism: true,
          x5_type: 'h5',
          x5_video_position: "center",
          x5_fullscreen: true,
          x5_orientation: 'portraint',
          x5LandscapeAsFullScreen: true,
          // controlBarVisibility: 'always',
          
          // skinLayout: [
            // {name: "bigPlayButton", align: "blabs", x: 30, y: 80},
            // {name:"liveDisplay", align:"tlabs", x: 0, y:0},
            // {name: "errorDisplay", align: "tlabs", x: 0, y: 0},
            // {name: "infoDisplay", align: "cc"},
            // {
            //   name: "controlBar", align: "blabs", x: 0, y: 0,
            //   children: [
            //     {name:"liveDisplay", align:"tlabs", x: 15, y:6},
            //     {name:"fullScreenButton", align:"tr", x:10, y: 10},
            //     {name:"subtitle", align:"tr",x:15, y:12},
            //     {name:"setting", align:"tr",x:15, y:12},
            //     {name:"volume", align:"tr", x:5, y:10}
            //   ]
            // }
          // ]
        },
        isScreen: false,
        liveData: [],
        goodslist: [],
        itId: '',
        liveCode: '',
        liveTitle: '',
        liveStart: '',
        liveStart1: '',
        liveEnd: '',
        secondTime: '',
        liveTime: '',
        coverUri: '',
        liveUri: '',
        roomDesc: '',
        playUri: '',
        picurl: '',
        anchor_name: '',
        url: '',
        urlimg: require('../../assets/liveimg/logo.svg'),
        backimg: require('../../assets/liveimg/back.png'),
        shareUri: 'http://testsaas.sslab.com.cn/plkhsy/logo.png',
        audience_num: '',
        isWaitTime: false,
        isliveTime: 3,
        isEndTime: false,
        isCover: false,
        openPopup: false,
        followPopup: false,
        isVideo1: true,
        starDate: null,
        endDate: null,
        giveTimer: null,
        giveClose: null,
        video: null,
        player: null,
        timePlayUri: '',
        liveStr: '',
        seeked: false,
        numLive: 1,
        istate: 0,
        link: '',
        posterImg: require('../../assets/liveimg/qrcode.png'),
        isOver: false,
        id: 'wxopenLanchAppId',
        appid: 'wxbaafb4b97fb87904',
        wechatOpenAppData: '',
        text: '',
        sliderStyle:{
          // width: '',
          height: '',
        }
      }
    },
    created(){
      // this.sliderStyle.width = window.screen.width + 'px'
      this.sliderStyle.height = window.screen.height + 'px'
      this.liveCode = this.$route.query.liveCode
      this.getendstate()
      let json = {
        "liveCode": this.liveCode
      }
      this.wechatOpenAppData = JSON.stringify(json)
      if (iswx() === true) {
        let wechat = navigator.userAgent.match(/MicroMessenger\/([\d\.]+)/i);
        console.log('wechat',wechat)
        let judgewechat = wechat[1].split('.')
        if(judgewechat[0]>=7){
          if(judgewechat[1]>=0){
            if(judgewechat[2]>=12){
              this.openPopup = true
              console.log("当前符合 h5 打开指定app")                    
            }
          }
        }
      }
      // console.log('json',this.wechatOpenAppData)

      // this.$nextTick (function () {
      //   this.qrcode();
      // })
    },
    mounted() {
      // 检测断网
      window.addEventListener("offline", () => {
        console.log("已断网");
        this.isEndTime = true;
        this.isVideo1 = false;
        this.isliveTime = ''
        this.isOver = true
        this.liveStr = '断网，请重新连接网络...'
      });
      window.addEventListener("online", () => {
        console.log("网络已连接");
        this.isOver = false
        this.reload()
      });
      if (this.openPopup == true) {
        var btn = document.getElementById(this.id)
        btn.addEventListener('launch', e => {
          console.log('success');
        });
        btn.addEventListener('error',  e => {
          this.text = e.detail.errMsg
          if (e.detail.errMsg == 'launch:fail') {
            window.location = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.sslab.customer'
          } else {
            this.$createToast({
              txt: e.detail,
              type: 'error'
            }).show()
          }
        });
      }
    },
    methods: {
      // openScreen() {
      //   var docElm = document.documentElement;

      //   if (docElm.requestFullscreen) {
      //     docElm.requestFullscreen();
      //   } else if (docElm.mozRequestFullScreen) {
      //     docElm.mozRequestFullScreen();
      //   } else if (docElm.webkitRequestFullScreen) {
      //     docElm.webkitRequestFullScreen();
      //   }
      // },
      // 二维码
      qrcode () {
        this.link = 'https://www.baidu.com'
        let qrcode = new QRCode(this.$refs.qrcodeContainer, {
            width: 137,
            height: 137,        // 高度
            text:  this.link,   // 二维码内容
            // render: 'table' ,   // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
            // background: '#f0f',   // 背景色
            // foreground: '#ff0'    // 前景色
        })
        let canvas = document.getElementsByTagName('canvas')[0];
        let img = this.convertCanvasToImage(canvas);
        this.$refs.qrCode.append(img);
      },
      convertCanvasToImage(canvas) { 
        let image = new Image(); 
        image.src = canvas.toDataURL("image/png");  
        return image; 
      }, 
      // 获取直播信息
      async shareVideoInfo() {
        let data = {
          liveCode: this.liveCode,
        }
        const res = await liveDetail(data)
        console.log(res)
        try {
          if (res.data.code === 200) {
            let reg = new RegExp("\r\n", "g");
            this.liveData = res.data.data
            this.url = this.liveData.storePicture?this.liveData.storePicture:this.urlimg
            this.backimg = this.liveData.backgroundImg?this.liveData.backgroundImg:this.backimg
            this.posterImg = this.liveData.qrCodeImg?this.liveData.qrCodeImg:this.posterImg
            this.anchor_name = this.liveData.storeName
            this.playUri = this.liveData.httpLive
            this.roomDesc = this.liveData.liveRoomNotice.replace(reg, "<br/>")
            this.coverUri = this.liveData.liveBeforeNoticeImg
            this.liveUri = this.liveData.liveCoverImg
            this.liveTime = this.liveData.videoLiveTime
            this.secondTime = secondToDate(this.liveTime)
            this.liveStart1 = this.liveData.liveStartTime
            this.liveStart = this.liveData.liveStartTime.replace(/-/g, "/")
            this.liveEnd = this.liveData.liveEndTime.replace(/-/g, "/")
            this.liveTitle = this.liveData.liveTitle
            this.audience_num = this.liveData.viewers

            this.options.source = this.playUri
            this.options.cover = this.liveUri

            if (this.liveData.goods.length > 0){
              this.goodslist = this.liveData.goods
              this.shareUri = this.liveData.goods[0].goodsPicture
            }
              console.log('正片开始')
            // this.liveStart = ('2020-07-30 13:10:00').replace(/-/g, "/");
            // this.liveEnd = ('2020-07-24 14:50:00').replace(/-/g, "/");
            // console.log('this.istate=',this.istate)
            // console.log('this.shareUri=',this.shareUri)

            let videodesc = '直播时间：'+this.liveData.liveStartTime
            wxshare(this.shareUri,this.liveTitle,videodesc);
            let that = this
            if (new Date(this.liveStart) > new Date()) {
              this.isEndTime = false;
              this.isVideo1 = false;
              this.isWaitTime = true;
              this.isliveTime = 1;
              this.waitTime()
              console.log('预告片开始')
            } else if (this.istate == 1) {
              this.isEndTime = true;
              this.isVideo1 = false;
              this.isliveTime = 2;
              this.liveStr = '直播结束'
              console.log('直播已结束')
            } else {
              this.isEndTime = false;
              this.isVideo1 = true;
              this.timePlayUri = this.playUri
              this.picurl = this.liveUri;
              this.isliveTime = 3;
              // this.livePlayer()
              console.log('正片开始')
            }
          } else {
            this.$createToast({
              txt: res.data.msg,
              type: 'error'
            }).show()
          }
        } catch (error) {}
      },
      // 播放直播
      handleReady(e){
        this.isScreen = true
        console.log(`ready`,e);
      },
      // livePlayer(type) {
      //   let that = this
      //   that.player = new Aliplayer({
      //     "id": "player-con",
      //     "source": that.timePlayUri,
      //     'cover': that.picurl,
      //     "width": "100%",
      //     "height": "100%",
      //     "autoplay": false,
      //     "isLive": true,
      //     "rePlay": false,
      //     "playsinline": true,
      //     "preload": true,
      //     disableSeek: true,
      //     "skinLayout": [{name: "bigPlayButton", align: "blabs", x: 0, y: 80}],
      //     // skinLayout: [
      //     //   {name: "bigPlayButton", align: "blabs", x: 30, y: 80},
      //     //   {name: "errorDisplay", align: "tlabs", x: 0, y: 0},
      //     //   {name: "infoDisplay", align: "cc"},
      //     //   {
      //     //     name: "controlBar", align: "blabs", x: 0, y: 0,
      //     //     children: [
      //     //       {name:"liveDisplay", align:"tlabs", x: 15, y:6},
      //     //       {name:"fullScreenButton", align:"tr", x:10, y: 10},
      //     //       {name:"subtitle", align:"tr",x:15, y:12},
      //     //       {name:"setting", align:"tr",x:15, y:12},
      //     //       {name:"volume", align:"tr", x:5, y:10}
      //     //     ]
      //     //   }
      //     // ],
      //     // controlBarVisibility: "always",
      //     "controlBarVisibility": "hover",
      //     "useH5Prism": true
      //   },function(player){
      //     let u = navigator.userAgent;
      //     let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      //     // console.log('liveEnd=',that.liveEnd)
      //     player.on('onM3u8Retry',function(){
      //       if (that.numLive == 1) {
      //         console.log('直播失败')
      //         that.getendtime()
      //       }
      //       that.numLive++
      //     })
      //     if (isIOS) {
      //       player.on('canplaythrough',function  (e) {
      //         if(!that.seeked) {
      //           // console.log('seeked1=',that.seeked)
      //           // console.log('liveTime1=',that.liveTime)
      //           that.seeked = true;
      //           if (parseInt(that.liveTime) > 0) {
      //             // let num1 = 600
      //             let num1 = parseInt(that.liveTime)
      //             player.seek(num1)
      //             player.play()
      //           } else {
      //             player.play()
      //           }
      //         }
      //       });
      //     } else {
      //       // console.log('seeked2=',that.seeked)
      //       // console.log('liveTime2=',that.liveTime)
      //       if (parseInt(that.liveTime) > 0) {
      //         // let num = 400
      //         let num = parseInt(that.liveTime)
      //         player.seek(num)
      //         player.play()
      //       } else {
      //         player.play()
      //       }
      //     }
      //     if (new Date(that.liveEnd) > new Date()) {
      //       // that.endDate = setInterval(that.timerEnd,1000)
      //       // that.giveTimer = setInterval(that.giveTimerData,60000)
      //       that.giveClose = setInterval(that.giveTimerClose,30000)
      //     }
      //   });
      // },
      // 判断时间直播开始和直播结束
      timerstar() {
        console.log('1')
        if (new Date(this.liveStart)-new Date() <= 0) {
          this.reload()
          clearInterval(this.starDate)
          console.log('时间开始')
        }
      },
      timerEnd() {
        console.log('2')
        if (new Date(this.liveEnd)-new Date() <= 0) {
          this.reload()
          clearInterval(this.endDate)
          console.log('时间结束')
        }
      },
      giveTimerData() {
        console.log('3')
        if (new Date(this.liveEnd)-new Date() <= 0) {
          clearInterval(this.giveTimer)
          console.log('获取已直播时间结束')
        } else {
          this.giveTimeData()
        }
      },
      // 等待直播
      waitTime() {
        let that = this
        if (new Date(that.liveStart) > new Date()) {
          that.starDate = setInterval(that.timerstar,1000)
        }
      },
      // 获取直播结束状态
      async getendstate() {
        let data = {
          liveCode: this.liveCode
        }
        const res = await liveStatus(data)
        // console.log(res)
        try {
          if (res.data.code == 200) {
            this.istate = res.data.data
            this.shareVideoInfo()
          }
        } catch (error) {}
      },
      async getendtime() {
        let data = {
          liveCode: this.liveCode
        }
              console.log('主播网路正在连接')
        const res = await liveStatus(data)
        console.log(res)
        try {
          if (res.data.code == 200) {
            this.istate = res.data.data
            clearInterval(this.giveClose)
            if (res.data.data == 0) {
              this.isEndTime = true;
              this.isVideo1 = false;
              this.isliveTime = ''
              this.liveStr = '网路不好请刷新页面重新连接...'
              console.log('主播网路正在连接')
            } else {
              this.isEndTime = true;
              this.isVideo1 = false;
              this.isliveTime = 2;
              this.liveStr = '直播结束'
              console.log('主播时间结束')
            }
          }
        } catch (error) {}
      },
      // 获取已下播信号
      async giveTimerClose() {
        let data = {
          liveCode: this.liveCode,
        }
        const res = await liveStatus(data)
        console.log('获取下播时间')
        try {
          if (res.data.code == 200) {
            this.istate = res.data.data
            clearInterval(this.endDate)
            clearInterval(this.giveTimer)
            if (res.data.data == 1) {
              this.isEndTime = true;
              this.isVideo1 = false;
              this.isliveTime = 2;
              this.liveStr = '直播结束'
              console.log('主播时间结束')
            }
          }
        } catch (error) {}
      },
      // 获取已直播时间
      async giveTimeData() {
        let data = {
          liveCode: this.liveCode,
        }
        const res = await liveDetail(data)
        console.log('获取已直播时间')
        try {
          if (res.data.code === 200) {
            this.audience_num = res.data.data.viewers
            this.secondTime = secondToDate(res.data.data.videoLiveTime)
          }
        } catch (error) {}
      },
      // 点击关注，直播暂停 
      wechatClose() {
        this.followPopup = false
        this.popupShow(2)
      },
      // 关闭关注，直播开始 
      followshow() {
        this.followPopup = true
        this.popupShow(1)
      },
      wechatDow() {
        window.location = 'http://192.168.1.47:9526/logo.png'
      },
      // 点击弹窗 暂停播放方法
      popupShow(type) {
        if (new Date(this.liveStart) > new Date()) {
          this.isEndTime = false;
          this.isVideo1 = false;
          this.isWaitTime = true;
          console.log('预告片开始1')
        } else if (this.istate == 1) {
          this.isEndTime = true;
          this.isVideo1 = false;
          this.liveStr = '直播结束'
          console.log('直播已结束1')
        } else {
          if (type == 1) {
            this.isEndTime = true;
            this.isVideo1 = false;
            if (this.isOver == false) {
              this.player.pause()
            }
            console.log('直播暂停')
          } else if (this.liveStr == '网路不好请刷新页面重新连接...') {
            this.isEndTime = true;
            this.isVideo1 = false;
            if (this.isOver == false) {
              this.player.pause()
            }
            console.log('网路不好')
          } else {
            if (this.isOver == false) {
              this.isEndTime = false;
              this.isVideo1 = true;
              this.player.play()
            }
            console.log('直播开始')
          }
        }
      },
      // 点击打开APP，直播暂停
      openAppShow() {
        this.openPopup = true
        this.popupShow(1)
      },
      // 点击关闭APP，直播开始
      openAppClose() {
        this.openPopup = false
        this.popupShow(2)
      },
      // 打开APP
      openApp() {
        window.location = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.sslab.customer'
      },
      handleErrorFn(e){
				this.wechatOpenAppData ="【这里是error 函数】"+ JSON.stringify(e)
				if (e.isTrusted == false) {
					window.open("https://a.app.qq.com/o/simple.jsp?pkgname=com.sslab.customer")
				}
			},
			handleLaunchFn(e){
				this.wechatOpenAppData ="【这里是launch 函数】"+ JSON.stringify(e)
      },
      openScreen() {
        // this.player.requestFullScreen()
        this.$refs.VueAliplayerV2.requestFullScreen()
      }
      
      //使用html2canvas生成海报
      // createPoster() {
      //   // 生成海报
      //   const vm = this
      //   const domObj = document.getElementById('myQRCode')
      //   html2canvas(domObj,{useCORS: true,logging: false,}).then(function(canvas) {
      //     // 在微信里,可长按保存或转发 posterImg 生成的海报路径
      //     vm.posterImg = canvas.toDataURL('image/png')
      //     console.log('111111=',vm.posterImg)
      //     vm.mask = true;
      //   })
      // },
    }
  }
</script>

<style lang="scss">
  .home {
    max-width: 768px;
    margin: 0 auto;
    background: rgba($color: #000000, $alpha: 0.5);
  }
  .home-back {
    max-width: 768px;
    margin: 0 auto;
    // display: flex;
    // flex-direction: column;
    position: fixed;
    bottom: 0;
    top: 0;
    left: 0;
    right: 0;
    z-index: -999;
    .home-back-img {
      img {
        width: 100%;
        filter:blur(10px);
      }
    }
  }
  .prism-player {
    z-index: 1;
  }
  .prism-info-display {
    padding: 0!important;
  }
  .prism-controlbar {
    display: none !important;
  }
  .prism-big-play-btn {
    left: 50%!important;
    top: 50%!important;
    margin-left: -32px!important;
    margin-top: -32px!important;
  }

  .live-header {
    display: flex;
    padding: 0.1rem 0.15rem 0.9rem;
    font-size: 0;
    z-index: 99999;
    .live-header-left {
      flex: 0 0 2rem;
      display: flex;
      background: rgba(0,0,0,0.3);
      border-radius: 0.18rem;
      .header-left-img {
        flex: 0 0 0.35rem;
        img {
          width: 0.35rem;
          height: 0.35rem;
          border-radius: 50%;
        }
      }
      .header-left-sub {
        flex: 1;
        align-self: center;
        padding: 0.05rem;
        text-align: left;
        .header-left-title {
          display: -webkit-box;
          overflow: hidden;
          text-overflow: ellipsis;
          word-wrap: break-word;
          white-space: normal !important;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          // padding: 0.05rem 0 0;
          font-size: 0.14rem;
          color: #fff;
        }
        .header-left-up {
          padding-top: 0.02rem;
          font-size: 0.1rem;
          color: #dedede;
        }
      }
      .header-left-follow {
        flex: 0 0 0.5rem;
        margin: 0.05rem  0.05rem 0 0;
        height: 0.25rem;
        line-height: 0.25rem;
        text-align: center;
        font-size: 0.12rem;
        color: #fff;
        background: #FB3D3D;
        border-radius: 0.4rem;
      }
    }
    .live-header-right {
      flex: 1;
      text-align: right;
      align-self: center;
      .header-right-text {
        display: inline-block;
        width: 0.4rem;
        height: 0.26rem;
        line-height: 0.26rem;
        background: rgba(0,0,0,0.3);
        border-radius: 0.13rem;
        text-align: center;
        font-size: 0.1rem;
        color: #fff;
      }
    }
  } 
  
  .liveB {
    position: relative;
    height: 2.1rem;
    background: #000;
    .all {
      position: absolute;
      width: 0.54rem;
      height: 0.4rem;
      bottom: 0px;
      right: 0px;
      z-index: 99999;
      font-size: 0;
      img {
        margin-top: 0.05rem;
        width: 0.3rem;
        height: 0.3rem;
      }
    }
    .videobox {
      height: 2.1rem;
      z-index: 2;
    }
  }

  .entTime{
    width: 100%;
    height: 2.1rem;
    position: absolute;
    top: 0;
    left: 0;
    img {
      width: 100%;
      height: 2.1rem;
    }
    .cover-over {
      width: 100%;
      height: 2.1rem;
      line-height: 1.6rem;
      position: absolute;
      top: 0;
      left: 0;
      background: rgba($color: #000000, $alpha: 0.6);
      span {
        font-size: 0.14rem;
        font-weight: 600;
        color: #fff;
        letter-spacing: 0.03rem;
      }
    }
  }
  
  .waitTime{
    width: 100%;
    height: 2.1rem;
    position: absolute;
    top: 0;
    left: 0;
    img {
      width: 100%;
      height: 2.1rem;
    }
  }

  .notice-box {
    padding: 1rem 0.15rem 0.1rem 0.15rem;
    .notice-text {
      padding: 0.1rem;
      font-size: 0.14rem;
      font-weight: 500;
      text-align: left;
      line-height: 0.2rem;
      background: rgba(0,0,0,0.3);
      border-radius: 0.06rem;
      word-break:break-all;
      color: #FBCE00;
      strong {
        margin-right: 0.05rem;
        font-size: 0.14rem;
      }
    }
  }

  .recommend-box {
    width: 2rem;
    min-height: 0.4rem;
    padding: 0.14rem 0;

    .recommend-info {
      font-size: 0;
      .recommend-info-box {
        display: flex;
        height: 0.6rem;
        padding: 0.02rem;
        border-radius: 0.02rem;
        background: #fff;
        margin-bottom: 0.1rem;
        .recommend-info-img {
          flex: 0 0 0.6rem;
          img {
            width: 0.6rem;
            height: 0.6rem;
          }
        }
        .recommend-goods-box {
          flex: 1;
          position: relative;
          padding-left: 0.08rem;
          .recommend-goods-title {
            padding-top: 0.05rem;
            display: -webkit-box;
            overflow: hidden;
            text-overflow: ellipsis;
            word-wrap: break-word;
            white-space: normal !important;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            text-align: left;
            font-size: 0.12rem;
            color: #4a4a4a;
          }
          .recommend-price-box {
            display: flex;
            position: absolute;
            bottom: 0;
            width: 96%;
            font-size: 0;
            .recommend-price-text {
              flex: 1;
              height: 0.3rem;
              line-height: 0.3rem;
              text-align: left;
              font-size: 0.12rem;
              font-weight: bold;
              color: #FF172F;
            }
            .recommend-price-img {
              flex: 0 0 0.3rem;
              align-self: center;
              margin-right: 0.05rem;
              img {
                width: 0.2rem;
                height: 0.2rem;
              }
            }
          }
        }
      }
    }
  }

  
  .openappbox {
    padding: 0 0.15rem 1rem;
    text-align: center;
    font-size: 0;
    .app-img {
      display: inline-block;
      width: 100%;
      height: 0.54rem;
      img {
        width: 100%;
      }
    }
  }

  .live-info {
    display: flex;
    font-size: 0;
    color: #fff;
    padding: 0.1rem;
    background: #242424;
    .live-anchor-info {
      flex: 1;
      display: flex;
      .anchor-info-img {
        flex: 0 0 0.32rem;
        margin-left: 0.05rem;
        align-self: center;
        img {
          width: 0.32rem;
          height: 0.32rem;
        }
      }
      .anchor-info-text {
        flex: 1;
        margin-left: 0.1rem;
        align-self: center;
        text-align: left;
        font-size: 0.15rem;
        font-weight: 600;
      }
    }
    .live-time-info {
      flex: 1;
      display: flex;
      justify-content: flex-end;
      .startime {
        flex: 1;
        align-self: center;
        font-size: 0.1rem;
      }
      .time-info-img {
        display: inline-block;
        align-self: center;
        padding-right: 0.05rem;
        // border-right: 0.01rem solid #818181;
        img {
          width: 0.1rem;
          height: 0.08rem;
        }
        span {
          margin-left: 0.05rem;
          font-size: 0.1rem;
        }
      }
      .time-info-text {
        display: inline-block;
        margin-left: 0.05rem;
        text-align: right;
        align-self: center;
        font-size: 0.1rem;
      }
    }
  }
  .openapp-back {
    background: #f4f4f4;
  }

  .work_top{
    margin-left: 0.15rem;
    padding-bottom: 0.15rem;
    border-bottom: 0.01rem solid #efefef;
    h2 {
      text-align: left;
      font-size: 0.18rem;
      .pic{
        width: 0.2rem;
        vertical-align: middle;
        margin-right: 0.05rem;
      }
      span {
        font-weight: 600;
      }
    }
  }

  .work_anchor {
    display: flex;
    padding: 0.1rem 0.15rem;
    border-bottom: 0.1rem solid #F5F5F5;
    .work_anchor_img {
      flex: 1;
      display: flex;
      align-self: center;
      text-align: left;
      font-size: 0;
      .anchor_img {
        flex: 0 0 0.4rem;
        img {
          width: 0.4rem;
          height: 0.4rem;
          border-radius: 50%;
        }
      }
      .anchor_content {
        flex: 1;
        align-self: center;
        margin-left: 0.05rem;
        .anchor_name {
          font-size: 0.15rem;
          font-weight: bold;
          color: #242424;
        }
        .anchor_profession {
          padding-top: 0.05rem;
          font-size: 0.12rem;
          color: #999999;
        }
      }
    }
    .work_anchor_num {
      flex: 0 0 1rem;
      align-self: center;
      text-align: right;
      font-size: 0;
      .anchor_num {
        display: inline-block;
        padding: 0.06rem 0.1rem;
        text-align: center;
        border-radius: 0.12rem;
        font-size: 0.12rem;
        font-weight: 400;
        color:#fff;
        background: linear-gradient(#127be4, #00a4ff);
      }
    }
  }
  .work_buttom {
    padding: 0.2rem 0 0.5rem 0.15rem;
    h2 {
      text-align: left;
      padding-bottom: 0.16rem;
      font-size: 0.15rem;
      font-weight: bold;
      color: #242424;
      border-bottom: 0.01rem solid #efefef;
    }
    .notice-box {
      padding: 0.14rem 0 0.1rem;
      font-size: 0;
      text-align: left;
      img {
        width: 0.2rem;
        height: 0.2rem;
        vertical-align: middle;
      }
      span {
        margin-left: 0.02rem;
        font-size: 0.14rem;
        font-weight: bold;
        vertical-align: middle;
      }
    }
    p {
      text-align: left;
      padding: 0 0.1rem 0.06rem 0;
      font-size: 0.12rem;
      line-height: 0.2rem;
      color: #4a4a4a;
    }
  }

  .video_rgba{
    width:100%;
    height: 2.6rem;
    position: absolute;
    top:0;
    left: 0;
    background: url("../../assets/liveimg/aaa.png");
    z-index: 999;
    text-align: center;
    display: none;
  }
  .video_rgba p{
    font-size: 0.14rem;
    margin-top: 0.9rem; 
    color:#fff;
    margin-bottom: 0.25rem;
  }
  .video_rgba button{
    background: none;
    background: #0097E0;
    font-size: 0.14rem;
    border:none;
    border-radius: 0.20rem;
    padding: 0.1rem 0.4rem;
    color:#fff;
  }

  .videonav {
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 99999;
    width: 100%;
    height: 0.4rem;
    color: #fff;
    background: #000;
  }
  .van-overlay {
    z-index: 9999;
    // top: 30px;
  }

  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    font-size: 0;
    z-index: 999;
  }

  .block {
    font-size: 0;
    text-align: center;
    .msgbox {
      width: 3rem;
      padding: 0.2rem 0 0.14rem;
      background-color: #fff;
      border-radius: 0.1rem;
      h3 {
        text-align: center;
        font-size: 0.15rem;
        font-weight: bold;
        padding-bottom: 0.2rem;
      }
      p {
        padding-bottom: 0.01rem;
        height: 0.2rem;
        line-height: 0.2rem;
        text-align: center;
        font-size: 0.14rem;
        color: #333;
        font-weight: 400;
      }
      .openapp-button {
        display: inline-block;
        padding-top: 0.2rem;
        width: 2.3rem;
        height: 0.54rem;
        img {
          width: 100%;
        }
      }
    }
    .old-close {
      display: inline-block;
      margin-top: 0.2rem;
      img {
        width: 0.35rem;
        height: 0.35rem;
      }
    }
  }

  .wrapper-popup {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    font-size: 0;
    z-index: 999;
  }

  .block-popup {
    font-size: 0;
    text-align: center;
    .msgbox {
      .msgbox-wechat {
        width: 230px;
        height: 281px;
        position: relative;
        background: url(../../assets/liveimg/popup.svg);
        // img {
        //   width: 2.2rem;
        //   height: 3rem;
        // }
        .wechat-logo {
          width: 230px;
          position: absolute;
          top: -0.25rem;
          text-align: center;
          img {
            width: 0.5rem;
            height: 0.5rem;
            border-radius: 50%;
          }
        }
        .wechat-title {
          width: 230px;
          position: absolute;
          top: 0.4rem;
          text-align: center;
          span {
            display: inline-block;
            font-size: 0.16rem;
            font-weight: 500;
            color: #ffffff;
          }
        }
        .wechat-close {
          width: 0.2rem;
          height: 0.2rem;
          position: absolute;
          top: 0.05rem;
          right: 0.08rem;
          img {
            width: 0.2rem;
            height: 0.2rem;
          }
        }
        .wechat-qrcode {
          width: 230px;
          position: absolute;
          top: 0.65rem;
          text-align: center;
          .QRCode {
            display: inline-block;
            padding: 0.05rem;
            background: #fff;
            img {
              width: 137px;
              height: 137px;
            }
          }
        }
        .wechat-text {
          width: 230px;
          position: absolute;
          bottom: 0.2rem;
          text-align: center;
          span {
            display: inline-block;
            padding: 0 0.1rem;
            line-height: 0.15rem;
            font-size: 0.1rem;
            color: #4a4a4a;
            font-weight: 600;
          }
        }
        .wechat-button {
          width: 230px;
          height: 0.4rem;
          position: absolute;
          bottom: -0.15rem;
          text-align: center;
          img {
            width: 2rem;
            height: 0.4rem;
          }
        }
      }
    }
  }

  .msgbox-botton {
    position: relative;
    display: inline-block;
    width: 100%;
    height: 0.45rem;
    margin-top: 0.2rem;
    background: linear-gradient(147deg,#ff6666 30%, #f82a19 76%);
    border-radius: 0.04rem;
    font-size: 0.15rem;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
    text-align: center;
    color: #ffffff;
    line-height: 0.45rem;
    strong {
      margin-left: 0.2rem;
    }
    .launch-btn {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      z-index: 1;
      opacity: 0;
    }
  }

</style>